import { Dispatch, SetStateAction, useState } from 'react';
import * as yup from 'yup';
import { Procedure } from 'types/procedure';

export type ProcedureValidation = {
  name?: string;
  sale_price?: string;
};

type UseProcedureValidation = [
  ProcedureValidation,
  Dispatch<SetStateAction<ProcedureValidation>>,
  (procedure: Procedure) => Promise<void>,
];

export function useProcedureValidation(): UseProcedureValidation {
  async function handleValidation(procedure: Procedure) {
    const schema = yup.object().shape({
      sale_price: yup.string().required('O preço de venda é obrigatório'),
      name: yup.string().required('O nome do procedimento é obrigatório'),
    });

    try {
      await schema.validate(procedure);
    } catch (err) {
      const error = err as yup.ValidationError;
      if (error.path && error.message) {
        setValidation({
          [error.path]: error.message,
        });
      }
      throw new Error(err as string);
    }
  }

  const [validation, setValidation] = useState<ProcedureValidation>({});
  return [validation, setValidation, handleValidation];
}
